import _ from 'lodash';
import { showModal } from "Store/auth";
import axios, { type AxiosRequestConfig } from "axios";
import { applyApiTimeout } from "Constants/services/axiosApiTimeout";
//https://corsproxy.io/? if this is the issue lets this will integrate from the OOT.

const getConfiguratorBaseUrl = (): string => {
  const base = process.env.REACT_APP_CONFIGURATOR ?? '';
  return base.endsWith('/') ? base.slice(0, -1) : base;
};

class CONFIGURATOR_API {
  accessToken: string | undefined;
  email: string | undefined;
  idtoken: string | undefined;
  redX: { dispatch: (action: unknown) => void } | undefined;
  configUrl: string | undefined;
  constructor() {
    //this.interceptRequests();
  }
  init({
    accessToken,
    email,
    idtoken,
    redX,
  }: {
    accessToken: string;
    email: string;
    idtoken: string;
    redX: { dispatch: (action: unknown) => void };
  }) {
    if (accessToken && email) {
      this.accessToken = accessToken;
      this.email = email;
      this.idtoken = idtoken;
      this.redX = redX;
      // this.configUrl = configUrl;
    } else {
      return { msg: "Failed to initiate." };
    }
  }
  interceptRequests() {
    axios.interceptors.response.use((response) => {
      if (response.data.errorCode === 401 &&
        (
          response.data.errorMessage.trim().toUpperCase().includes("TOKEN ERROR") ||
          response.data.errorMessage.trim().toUpperCase().includes("TOKEN EXPIRED")
        )
      ) {
        this.redX?.dispatch(showModal({ msg: "Please log in again now...", variant: "ERROR", title: response.data.errorMessage.trim().toUpperCase(), show: true }))
        // Show the message 5 second and redirect the page to login

      }
      else if (response.data.errorCode == 401) {
        this.speak(401);
      }
      if (!response.data.status) {
        this.speak(500, { msg: response.data.errorMessage, panel: { title: 'More details', msg: response.data.stacktrace } })
      }
      return response;
    }, (error) => {
      this.speak(500, { msg: error, panel: { title: '', msg: '' } })
      return Promise.reject(error);;
    })
    axios.interceptors.request.use((request) => {
      request.headers["Content-Type"] = "application/json; charset=UTF-8";
      request.headers["Authorization"] = "Bearer " + this.accessToken;
      delete request.headers["idtoken"];
      request.headers["idtoken"] = this.idtoken;
      // Timeout + bypasses: single source in axiosApiTimeout.ts
      applyApiTimeout(request);
      return request;
    })
  }
  speak(code: number, info = { msg: '', panel: { title: '', msg: '' } }) {
    switch (code) {
      case 401:
        this.redX?.dispatch(showModal({ msg: "Please Reload to continue , If you have any unsaved data, close this message and copy the data before logging in again. If not, please log in again now.", variant: "ERROR", title: "Session Timed Out", show: true }))
        break;
      case 200:
        break;
      case 500:
        this.redX?.dispatch(showModal({
          msg: info.msg, variant: "ERROR", title: "Something went wrong", show: true, panel: {
            msg: info.panel.msg,
            title: info.panel.title
          }
        }))
        break;
    }
  }

  // get segment solution list on select of segments
  getSegmentList = async () => {
    const params = `?_format=json&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: process.env.REACT_APP_CONFIGURATOR + '/segment/list' + params,
    });
    return res.data;
  };

  // get segment solution form on select of solution
  getSegmentForm = async (solution: string) => {
    const params = `?_format=json&username=${this.email}`;
    const res = await axios({
      method: "get",
      url: process.env.REACT_APP_CONFIGURATOR + '/segment/' + solution + params,
    });
    return res.data;
  };

  segmentFormSubmission = async (method: string, solutionName: any, cartDataList: any, sid: string, eot_params?: string, undo?: boolean, owner_email?: string, intermediatePayload?: any) => {
    owner_email = owner_email ? owner_email : undefined;
    let params = `?_format=json&username=${this.email}&${eot_params}&owner_email=${owner_email}`;
    if (sid !== "" && sid !== undefined) {
      params = `?_format=json&username=${this.email}&sid=${sid}&${eot_params}&owner_email=${owner_email}`;
    }
    // if undo is true then validate is false
    params = undo ? params + '&validate=false' : params + '&validate=true';
    const res = await axios({
      method: method,
      url: process.env.REACT_APP_CONFIGURATOR + '/segment/' + solutionName + params,
      data: intermediatePayload ? intermediatePayload : cartDataList
    });
    return res.data
  }

  configuratorDataCallback = async (
    method: string,
    endPoint: string,
    args: string,
    post_data?: unknown,
  ) => {
    let params = `?_format=json&username=${this.email}`;
    endPoint = (endPoint).split('/api/configurator')[1];
    let joinargs = args.length > 0 ? '&' + args : '';
    let requestpayload = {};
    if (post_data) {
      const res = await axios({
        method: method,
        url: process.env.REACT_APP_CONFIGURATOR + endPoint + params + joinargs,
        data: post_data
      });
      return res.data;
    } else {
      requestpayload = {
        method: method,
        url: process.env.REACT_APP_CONFIGURATOR + endPoint + params + joinargs
      };
      const res = await axios(requestpayload);
      return res.data;
    }
    // const res = await axios(requestpayload);
    // return res.data;
  }

  // -------------- NDAC Ref solution APIs --------------------- //
  getPlannerAttachments = async (scrmid: string) => {
    const params = `?_format=json&username=${this.email}&scrmid=${scrmid}`;
    const res = await axios({
      method: "get",
      url: process.env.REACT_APP_NODE + '/api/odt/odt_ndacplanner' + params,
    });
    return res.data;
  };

  getZippedAttachment = async (attachmentid: string) => {
    const params = `?_format=json&username=${this.email}&attachmentid=${attachmentid}`;
    const res = await axios({
      method: "get",
      url: process.env.REACT_APP_NODE + '/api/odt/odt_ndacplannerAttachment' + params,
    });
    return res.data;
  };

  trimTrailingSlash(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }

  /**
   * Fetches the list of services from the configurator API.
   *
   * @returns {Promise<any>} A promise that resolves to the list of services.
  */
  fetchAvailableServices = async (
    searchValue: string | undefined = undefined,
    signal: AbortSignal | undefined = undefined,
  ) => {
    let params = `?_format=json&username=${this.email}`;
    if (searchValue) {
      params += `&keyword=${searchValue}`;
    }
    const __url = getConfiguratorBaseUrl();
    // axios request
    const config: AxiosRequestConfig = {
      method: "get",
      url: `${__url}/search/services${params}`,
    };
    // Conditionally add the signal to the config if AbortController is used
    if (signal) {
      config.signal = signal;
    }
    const res = await axios(config);
    return res.data;
  };

  /**
   * Fetches the list of services from the configurator API.
   *
   * @returns {Promise<any>} A promise that resolves to the list of services.
  */
  getCustomSericePriceList = async (
    param: Record<string, string | number | boolean | undefined> | undefined = undefined,
    savedServices: unknown = undefined,
    signal: AbortSignal | undefined = undefined,
  ) => {
    let __params = `?_format=json&username=${this.email}`;
    if (param && _.isEmpty(param) === false) {
      // add the parameters to the query string
      Object.keys(param).forEach((key) => {
        __params += `&${key}=${param[key]}`;
      });
    }
    const __url = getConfiguratorBaseUrl();
    // axios request
    const config: AxiosRequestConfig = {
      method: "post",
      url: `${__url}/customAddService${__params}`,
    };
    // Conditionally add the signal to the config if AbortController is used
    if (signal) {
      config.signal = signal;
    }
    if (savedServices) {
      config.data = savedServices;
    }
    const res = await axios(config);
    return res.data;
  };

  /**
   *
   * @param basicArgs
   * @returns
   */
  getMxieProductDetailsFromConfigurator = async (basicArgs: string) => {
    const __url = getConfiguratorBaseUrl();
    const config: AxiosRequestConfig = {
      method: "get",
      url: `${__url}/search/catalog_items_complete_search_sales_kit/?${basicArgs}`,
    };
    const res = await axios(config);
    return res.data;
  }

}
const CONFIG_API = new CONFIGURATOR_API();
export default CONFIG_API;